'use client';

import { datadogRum } from '@datadog/browser-rum';
import { getBotCookies } from '@repo/platform-utils/bot-cookies';
import { useEffect } from 'react';

export function DataDogBotData() {
  useEffect(() => {
    const { isBot, isVerifiedBot, botScore } = getBotCookies();
    datadogRum.startSessionReplayRecording();
    datadogRum.setUserProperty('is_bot', isBot);
    datadogRum.setUserProperty('is_verified_bot', isVerifiedBot);
    datadogRum.setUserProperty('bot_score', botScore);
  }, []);
  return null;
}
